import type { CSSProperties } from 'react';

// Skeleton-loading primitives (CLAUDE.md: skeleton loading is part of the shell).
// The `.skeleton` shimmer (`skel`, motion.css) is defined in theme.css. Duplicated per surface (CB-D3).
export function Skeleton({
  width,
  height,
  radius = 8,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: CSSProperties;
}) {
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      data-motion=""
      style={{ display: 'block', width: width ?? '100%', height: height ?? 16, borderRadius: radius, ...style }}
    />
  );
}

// A stack of row-shaped skeletons for the booking/verify lists while data loads.
export function ListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="booking-list" aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card booking-card">
          <Skeleton width="45%" height={16} />
          <Skeleton width="70%" height={12} />
          <Skeleton width="30%" height={12} />
        </div>
      ))}
    </div>
  );
}
